import { withStyles } from '@material-ui/core/styles';
import SnackbarVariant from './SnackbarVariant';
import {
    VARIANT_SUCCESS,
    VARIANT_ERROR,
    VARIANT_INFO,
    VARIANT_WARNING,
    VARIANT_DISABLED,
} from '../../constants';

const styles = theme => ({
    root: {
        maxWidth: 'inherit',
        flexWrap: 'nowrap',
    },
    [VARIANT_SUCCESS]: {
        backgroundColor: theme.palette.success.main,
    },
    [VARIANT_ERROR]: {
        backgroundColor: theme.palette.error.dark,
    },
    [VARIANT_INFO]: {
        backgroundColor: theme.palette.primary.dark,
    },
    [VARIANT_WARNING]: {
        backgroundColor: theme.palette.warning.main,
    },
    [VARIANT_DISABLED]: {
        backgroundColor: theme.palette.primary.light,
    },
    message: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
    },
    messageRoot: {
        maxHeight: 'calc(100vh - 100px)',
        paddingRight: '15px',
        paddingLeft: '15px',
        overflow: 'auto',
    },
});

export default withStyles(styles)(SnackbarVariant);
